import React from 'react';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import {Accordion, AccordionItem, Divider} from "@heroui/react";

import { useAppSelector } from '@/app/store';
import FlexRow from '@/components/Common/FlexRow'
import { RoleContext } from '@/app/api/common';

export interface SidebarProps {
	opened:			boolean;
	location:		string;
}

const selectedClass =  "bg-[#1B69AA26]";

const Sidebar = (props: SidebarProps) => {
  const { t } = useTranslation();
  const logins = useAppSelector((state) => state.logins);
  
  const settCaption = t('sidebar:settings:caption');
  
  const [selectedKeys, setSelectedKeys] = React.useState(new Set<string>([]));
  const role = React.useContext(RoleContext);
  React.useEffect(() => {
    if (props.location.indexOf("settings/") > -1)
      setSelectedKeys(new Set<string>(["1"]));
  }, [props.location]);
  
  const isAdmin =	logins.login &&
  					logins.login.role == 'admin';
  const isAccess=(data?:string)=>{
    return isAdmin || role?.privilages?.includes(data ?? '')
  }
  // A local (project-scoped) user can only ever reach the ONE project they
  // belong to and is redirected straight into it, so the Projects LIST entry is
  // a dead end for them — hide it.
  const isLocalUser = !!logins.login?.local_project_id;
  const canDeleted =	isAccess("DeleteProjects") ||
  						isAccess("DeleteChannel") ||
  						isAccess("DeleteGlobalChannelList") ||
  						isAccess("DeleteGlobalUsers");

  return (
  <FlexRow flex={0}
           width="auto"
           direction="column"
           className={[
             'bg-[#F5F5F5] p-[16px] fixed left-0 top-[64px] bottom-0  z-50',
             'sidebar',
             //'overflow-hidden',
             props.opened ? 'w-[282px]' : 'w-[0px]',
             props.opened ? 'opacity-1' : 'opacity-0',
           ]}>
  <FlexRow direction="column"
           width="auto"
           className="w-[282px] px-[16px]">
  { !isLocalUser &&
    <SidebarRow icon="category"
                target="projects"
                location={props.location} />
  }
  { !isLocalUser && isAccess("ViewGlobalChannelLists")&&
    <SidebarRow icon="dvr"
                target="channel_lists"
                location={props.location} />
  }
  {/* {isAdmin &&
    <React.Fragment> */}
  { isAccess("ViewChannels")&&
      <SidebarRow icon="smart_display"
                target="channels"
                location={props.location} />
  }
  { (isAccess("ViewGlobalUsers") || isAccess("ChangeGlobalUsers")) &&
      <SidebarRow icon="manage_accounts"
                  target="users"
                  location={props.location} />
  }
    {/* </React.Fragment>
  } */}
    <Divider className="my-[4px]"/>
  {/* {isAdmin && */}
  { (isAccess("ViewApps") || isAccess("ChangeApps") || isAccess("ViewLanguages") || isAccess("ChangeLanguages") || isAccess("ViewTags") || isAccess("ChangeTags") || isAccess("ViewFirmware") || isAccess("ChangeFirmware") || isAccess("ViewTrackFormats") || isAccess("ChangeTrackFormats") || isAccess("ViewSclones") || isAccess("ChangeSclones") || isAccess("SeeAllProjects") || isAccess("ViewLogs") || canDeleted || role?.admin) &&
    <Accordion selectedKeys={selectedKeys}>
      <AccordionItem aria-label={settCaption}
                     key="1"
                     title={
                     <div className="r14">
                       { settCaption }
                     </div>
                     }
                     classNames={{
                       title: 'text-[#9E9E9E]',
                     }}
                     indicator={({ isOpen }) =>
                         <div className="material-icons !text-[--Dark-Grey]">
                           { isOpen ? 'expand_less' : 'expand_more' }
                         </div>
                     }
                     onClick={() => {
                     	setSelectedKeys(
                          new Set(
                          	selectedKeys.has("1")
                          	?	[]
                          	:	["1"]
                          )
                       );
                     }}
                     disableIndicatorAnimation={true}>
        { (isAccess("ViewApps"))&&
          <SidebarRow icon="extension"
                      target="settings:apps"
                      location={props.location} />
        }
        { role?.admin &&
          <SidebarRow icon="connected_tv"
                      set="outlined"
                      target="settings:epg"
                      location={props.location} />
        }
        { (isAccess("ViewLanguages"))&&
          <SidebarRow icon="language"
                      set="outlined"
                      target="settings:languages"
                      location={props.location} />
        }
        { (isAccess("ViewTags"))&&
          <SidebarRow icon="label"
                      target="settings:tags"
                      location={props.location} />
        }
        { role?.admin &&
          <SidebarRow icon='leaderboard'
                      target="settings:statistics"
                      location={props.location}/>         
        }
        { isAccess("ViewTrackFormats")&&
          <SidebarRow icon='tune'
                      target="settings:trackformats"
                      location={props.location}/>
        }
        { isAccess("ViewFirmware") &&
          <SidebarRow icon='system_update	'
                      target="settings:firmware"
                      location={props.location}/>
        }
        { (isAccess("ViewSclones") || isAccess("SeeAllProjects")) &&
          <SidebarRow icon='content_copy'
                      target="settings:clonesettings"
                      location={props.location}/>
        }
        { isAccess("ViewLogs")&&
          <SidebarRow icon='history'
                target='audit'
                location={props.location}/>
        }
        { role?.admin &&
          <SidebarRow icon='mail'
                      set="outlined"
                      target="settings:mailer"
                      location={props.location}/>
        }
        { role?.admin &&
          <SidebarRow icon='monitor_heart'
                      set="outlined"
                      target="settings:monitoring"
                      location={props.location}/>
        }
        { role?.admin &&
          <SidebarRow icon='shield'
                      set="outlined"
                      target="settings:system"
                      location={props.location}/>
        }
        { canDeleted &&
          <SidebarRow icon='delete_outline'
                      target="settings:deleted"
                      location={props.location}/>
        }
      </AccordionItem>
    </Accordion>
  }
  {/* } */}
  </FlexRow>
  </FlexRow>
  )
};

const iconSet = {
  "default":		"material-icons !text-[--Dark-Grey]",
  "outlined":		"material-icons-outlined !text-[--Dark-Grey]",
};

export interface SidebarRowProps {
  icon:			string;
  set?:			"default" | "outlined";
  target:		string;
  location:		string;
}

const SidebarRow = (props: SidebarRowProps) => {
  const { t } = useTranslation();
  
  const target = props.target.replace(":", "/");
  const link = "/" + (props.target == 'projects' ? '' : target);
  const classes = cx(
    'rounded-[6px] h-[40px] pl-[12px]',
    { 'bg-[#1B69AA26]': target == props.location }
  );
  
  const s =	props.set === undefined
  			?	"default"
  			:	props.set;
  
  //console.log("SidebarRow/link=" + link + "/target=" + target + "/props=", props);
  
  const iconClass = iconSet[s];
  
  return (
  <Link to={link}
        className="w-full">
    <FlexRow className={classes}>
      <span className={iconClass}>
        { props.icon }
      </span>
      <span className="text-black r16 ml-[12px]">
        { t('sidebar:' + props.target) }
      </span>
    </FlexRow>
  </Link>
  );
}

export default Sidebar;
